import { fetchWrapper } from "utils/apiFetch";

// apiService.js
const BASE_URL = "https://pro.mokshiq.in";

class ApiService {
  // Generic POST request with FormData
  static async postFormData(endpoint, formData) {
    try {
      const response = await fetchWrapper(`${BASE_URL}${endpoint}`, {
        method: 'POST',
        body: formData,
      });

    
      return response;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Generic POST request with JSON
  static async postJSON(endpoint, data) {
    try {
      const response = await fetchWrapper(`${BASE_URL}${endpoint}`, {
        method: 'POST',
      
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Profile update
  static async updateProfile(formData) {
    return this.postFormData('/profile_wl_update', formData);
  }
  static async sendPinOtp(userid) {
    return fetch(`/get_otp?userid=${userid}`);
  }

  // KYC details update
  static async updateKyc(formData) {
    return this.postFormData('/profile_wl_update', formData);
  }

  // Password change
  static async changePassword(data) {
    return this.postFormData('/change_password', data);
  }

  // PIN change
  static async changePin(data) {
    return this.postFormData('/change_transection_pin', data);
  }

  // Bank details update
  static async updateBankDetails(data) {
    return this.postFormData('/profile_wl_update', data);
  }

  // Role assignment
  static async assignRole(data) {
    return this.postFormData('/update_user_kyc_nd_all', data);
  }
  static async getUsersByRole(data) {
    return this.postFormData('/get_user_by_role', data);
  }
  static async updateUserMapping(data) {
    return this.postFormData('/update_user_mapping', data);
  }
  // Get service list for a member (filtered by logged-in user's services)
static async getServiceList(memberId) {
  const formData = new FormData();
  formData.append("action", "GETServiceList");
  formData.append("ret_idd", memberId);
  return this.postFormData('/retailer_action', formData);
}

// Save assigned services for a member
static async assignServiceList(memberId, serviceList) {
  const formData = new FormData();
  formData.append("action", "AssignServiceList");
  formData.append("id", memberId);
  formData.append("service_list", JSON.stringify(serviceList));
  return this.postFormData('/retailer_action', formData);
}

  // Scheme assignment
  static async assignScheme(data) {
    return this.postFormData('/update_user_kyc_nd_all', data);
  }

  // Mapping update
  static async updateMapping(data) {
    return this.postJSON('/update_mapping', data);
  }

  // KYC status update
  static async updateKycStatus(data) {
    return this.postFormData('/update_user_kyc_nd_all', data);
  }

  // Fund transfer
  static async fundTransfer(data) {
    return this.postFormData('/update_user_kyc_nd_all', data);
  }

  // Notification settings update
  static async updateNotificationSettings(data) {
    return this.postJSON('/update_notification_settings', data);
  }
}

export default ApiService;